import { ViewModel,View, ObservableArray, ViewGenerator } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { DataModel, DataModelClass } from "src/formBuilder/datamodel/structure";
import { FormBuilderViewModel } from "../formBuilder/formBuilder-viewModel";
import { TemplateCreatorViewModel } from "./templateCreator/templateCreator-viewModel";
import  { TemplateListView } from "./templateList-view"

export class TemplateListViewModel extends ViewModel{
    constructor(parentViewModel: FormBuilderViewModel) {
        super(parentViewModel);
        this.mediaTypeSelector = new MediaTypeSelector(this);
        this.mediaTypeSelector.selectById("0");

        this._typedParent = parentViewModel;
        this.templates = ObservableArray.create<TemplateViewModel>();
        this.noMediaTemplates = ObservableArray.create<NoMediaTemplateViewModel>();
    }

    private _typedParent : FormBuilderViewModel;    
    GetDefaultView(): View <ViewModel> {
        return new TemplateListView();
    }
    public getTypeId(): string {
        return "VM-6EEF51B0-D79E-445A-AAE3-3D50047527AF"
    }



    public set noMediaTemplates(v: ObservableArray<NoMediaTemplateViewModel>) { this._noMediaTemplates = v; } public get noMediaTemplates(): ObservableArray<NoMediaTemplateViewModel> { return this._noMediaTemplates;} private _noMediaTemplates: ObservableArray<NoMediaTemplateViewModel>;
    public set selectedNoMediaTemplate(v: NoMediaTemplateViewModel) { 
        this._selectedNoMediaTemplate = v; 
        if(v){
            this.mediaTypeSelector.items.forEach(x=>x.isExists = v.templates.filter(q=>q.mediaType.toString()==x.id).length>0);
        }else{
            this.mediaTypeSelector.items.forEach(x=>x.isExists = false);
        }
    } public get selectedNoMediaTemplate(): NoMediaTemplateViewModel { return this._selectedNoMediaTemplate;} private _selectedNoMediaTemplate: NoMediaTemplateViewModel;
        
    public set templates(v: ObservableArray<TemplateViewModel>) { this._templates = v; } public get templates(): ObservableArray<TemplateViewModel> { return this._templates;} private _templates: ObservableArray<TemplateViewModel>;
    public set dataModel(v: DataModel) { this._typedParent.dataModel = v; } public get dataModel(): DataModel { return this._typedParent.dataModel;};
    public set selectedTemplate(v: TemplateViewModel) { 
        this._selectedTemplate = v; 
        if(v){
            this.isMain = v.isMain;
            this.isDetail = v.isDetail;
        }else{
            this.isMain = false;
            this.isDetail = false;
        }
    } public get selectedTemplate(): TemplateViewModel { return this._selectedTemplate;} private _selectedTemplate: TemplateViewModel;
    public set isMain(v: boolean) { this._isMain = v; } public get isMain(): boolean { return this._isMain;} private _isMain: boolean;
    public set isDetail(v: boolean) { this._isDetail = v; } public get isDetail(): boolean { return this._isDetail;} private _isDetail: boolean;
    public set mediaTypeSelector(v: MediaTypeSelector) { this._mediaTypeSelector = v; } public get mediaTypeSelector(): MediaTypeSelector { return this._mediaTypeSelector;} private _mediaTypeSelector: MediaTypeSelector;
    
    async edit(){
        let selectedNoMedia = this.selectedNoMediaTemplate;
        if(selectedNoMedia==null)
            return;
        let mediaType = parseInt(this.mediaTypeSelector.selectedItem.id);
        let template = selectedNoMedia.templates.filter(x=>x.mediaType==mediaType).at(0);
        let isNew=false;
        if(template == null){
            template = selectedNoMedia.createNewTemplate(mediaType);
            isNew = true;
        }
        let isConfirmed = await this._typedParent.editTemplate(template,template.mediaType);
        if(isConfirmed && isNew){
            selectedNoMedia.templates.push(template);
            this.templates.push(template);
        }
    }

    makeMain(){
        this.noMediaTemplates.forEach(x=>x.isMain=false);
        this.selectedNoMediaTemplate.isMain = true;
    }
    makeDetail(){
        this.noMediaTemplates.forEach(x=>x.isDetail=false);
        this.selectedNoMediaTemplate.isDetail = true;
    }
    async createNew(){
        let creator = new TemplateCreatorViewModel(this);
        creator.loadInfo(this,this.dataModel);
        let newTemplate = await this.requestShowingPopup(creator);
        if(newTemplate){
            this.noMediaTemplates.push(newTemplate);
        }
    }
}

export class NoMediaTemplateViewModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.templates = ObservableArray.create<TemplateViewModel>();
    }
    
    public set name(v: string) { 
        this._name = v; 
        this.templates.forEach(x=>x.name=v);
    } public get name(): string { return this._name;} private _name: string;
    public set dataModelClass(v: DataModelClass) { 
        this._dataModelClass = v; 
        this.templates.forEach(x=>x.dataModelClass=v);
    } public get dataModelClass(): DataModelClass { return this._dataModelClass;} private _dataModelClass: DataModelClass;
    public set isMain(v: boolean) { 
        this._isMain = v; 
        this.templates.forEach(x=>x.isMain=v);
    } public get isMain(): boolean { return this._isMain;} private _isMain: boolean;
    public set isDetail(v: boolean) { 
        this._isDetail = v; 
        this.templates.forEach(x=>x.isDetail=v);
    } public get isDetail(): boolean { return this._isDetail;} private _isDetail: boolean;
    public set templates(v: ObservableArray<TemplateViewModel>) { this._templates = v; } public get templates(): ObservableArray<TemplateViewModel> { return this._templates;} private _templates: ObservableArray<TemplateViewModel>;
    
    createNewTemplate(mediaType: number): TemplateViewModel {
        let result = new TemplateViewModel(this);
        result.name = this.name;
        result.dataModelClass = this.dataModelClass;
        result.isMain = this.isMain;
        result.isDetail = this.isDetail;
        result.mediaType = mediaType;
        return result;
    }
    
}

export class TemplateViewModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set dataModelClass(v: DataModelClass) { this._dataModelClass = v; } public get dataModelClass(): DataModelClass { return this._dataModelClass;} private _dataModelClass: DataModelClass;
    public set jsonInfo(v: any) { this._jsonInfo = v; } public get jsonInfo(): any { return this._jsonInfo;} private _jsonInfo: any;
    public set htmlContent(v: any) { this._htmlContent = v; } public get htmlContent(): any { return this._htmlContent;} private _htmlContent: any;
    public set templateNode(v: any) { this._templateNode = v; } public get templateNode(): any { return this._templateNode;} private _templateNode: any;
    public set isMain(v: boolean) { this._isMain = v; } public get isMain(): boolean { return this._isMain;} private _isMain: boolean;
    public set isDetail(v: boolean) { this._isDetail = v; } public get isDetail(): boolean { return this._isDetail;} private _isDetail: boolean;
    public set mediaType(v: MediaTypes) { this._mediaType = v; } public get mediaType(): MediaTypes { return this._mediaType;} private _mediaType: MediaTypes;
    
    updateTemplateHtml(html: string) {
        this.htmlContent = html;
        if(stringIsNullOrEmpty(html)==false)
            this.templateNode = ViewGenerator.CreatePrototype(html,'3169b9c8-8886-4885-8962-b197e3c391b4');
    }
    
}

export enum MediaTypes{
    default =0,
    landscapeDefault=1,
    portraitDefault=2,
    portraitPhone=3,
    landscapePhone=4,
    portraitTablet=5,
    landscapeTablet=6,
    portraitLargeTablet=7,
    landscapeLargeTablet=8,
    desktop=9,
}

export class MediaTypeSelector extends SelectorBaseViewModel<MediaType>{
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    protected loadData(): Promise<MediaType[]> {
        let result = [
            new MediaType(this,"0","default"),
            new MediaType(this,"1","landscape Default"),
            new MediaType(this,"2","portrait Default"),
            new MediaType(this,"3","portrait Phone"),
            new MediaType(this,"4","landscape Phone"),
            new MediaType(this,"5","portrait Tablet"),
            new MediaType(this,"6","landscape Tablet"),
            new MediaType(this,"7","portrait Large Tablet"),
            new MediaType(this,"8","landscape Large Tablet"),
            new MediaType(this,"9","desktop"),
        ];
        return Promise.resolve(result);
    }
    
}

export class MediaType extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,id:string,name:string) {
        super(parent);
        
        this.id = id;
        this.name = name;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; this.updateTitle(); } public get name(): string { return this._name;} private _name: string;
    public set isExists(v: boolean) { this._isExists = v; this.updateTitle(); } public get isExists(): boolean { return this._isExists;} private _isExists: boolean;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;

    updateTitle(){
        this.title = `${this.name} ${this.isExists ? ` (exists)` : ''}`
    }
}